import React, { useContext, useEffect, useState } from 'react'
import { motion } from 'framer-motion';
import { MyContext } from '../Context/MyProvider';
import ImageLoad from './ImageLoad';
import { useNavigate } from 'react-router-dom';

const Banner = ({ images }) => {

    const { ImgBaseUrl } = useContext(MyContext);

    const [currentIndex, setCurrentIndex] = useState(0);
    const [isHover, setIsHover] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (isHover || !images?.length) return;

        const interval = setInterval(() => {
            setCurrentIndex((prev) =>
                prev === images.length - 1 ? 0 : prev + 1
            );
        }, 5000);

        return () => clearInterval(interval);
    }, [images, isHover]);

    const prev = () =>
        setCurrentIndex((i) => (i - 1 + images.length) % images.length);

    const next = () =>
        setCurrentIndex((i) => (i + 1) % images.length);

    const NavigateHandle = (title, id) => {
        navigate("/doctor-details");
        sessionStorage.setItem("Docdetails", JSON.stringify({ id: id, title: title, path: "/", pagename: "Home" }));
    }

    return (
        <div className="relative w-full pt-4 md:pb-4">
            <div className="banner-slider w-full mx-auto relative overflow-visible">
                <div className="flex items-center justify-center gap-6">
                    
                    <div className="hidden lg:block flex-shrink-0 w-[20%] opacity-30 blur-[2px] pointer-events-none">
                        <div className="relative w-full h-[280px] rounded-[16px] overflow-hidden shadow-sm">
                            <ImageLoad
                                src={ImgBaseUrl + images[(currentIndex - 1 + images.length) % images.length]?.image}
                                alt={"Previous"}
                                CustomeStyle={"w-full h-full object-cover"}
                            />
                        </div>
                    </div>

                    <div onMouseEnter={() => setIsHover(true)}
                        onMouseLeave={() => setIsHover(false)}
                        className="flex-shrink-0 w-full lg:w-[52%] duration-200">
                        <div className="relative w-full h-[190px] md:h-[320px] lg:h-[360px]">
                            {images?.map((item, index) => (
                                <motion.div
                                    key={index}
                                    initial={false}
                                    animate={{
                                        opacity: index === currentIndex ? 1 : 0,
                                        scale: index === currentIndex ? 1 : 0.90,
                                    }}
                                    transition={{ duration: 0.5, ease: 'easeInOut' }}
                                    className="absolute inset-0"
                                    style={{
                                        zIndex: index === currentIndex ? 10 : 5,
                                        pointerEvents: index === currentIndex ? 'auto' : 'none',
                                    }}
                                >
                                    <div onClick={() => NavigateHandle(item.department_name, item.department)} className="w-full h-full rounded-[20px] shadow-[0_4px_20px_rgba(0,0,0,0.15)] overflow-hidden cursor-pointer">
                                        <ImageLoad
                                            src={ImgBaseUrl + item.image}
                                            alt={`Banner ${index + 1}`}
                                            CustomeStyle={"w-full h-full object-cover"}
                                        />
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>

                    <div className="hidden lg:block flex-shrink-0 w-[20%] opacity-30 blur-[2px] pointer-events-none">
                        <div className="relative w-full h-[280px] rounded-[16px] overflow-hidden shadow-sm">
                            <ImageLoad
                                src={ImgBaseUrl + images[(currentIndex + 1) % images.length]?.image}
                                alt={"Next"}
                                CustomeStyle={"w-full h-full object-cover"}
                            />
                        </div>
                    </div>
                </div>

                <div className="hidden md:block">
                    <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-20 bg-white/90 backdrop-blur-sm px-3 py-2 rounded-full shadow-md">
                        {images.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => setCurrentIndex(index)}
                                className={`h-2 rounded-full transition-all ${index === currentIndex
                                    ? 'bg-[--button-color] w-6'
                                    : 'bg-gray-400 w-2 hover:bg-gray-500'
                                    }`}
                                aria-label={`Go to slide ${index + 1}`}
                            />
                        ))}
                    </div>
                </div>

                <div className="mt-[20px] block md:hidden">
                    <div className="flex items-center justify-center gap-[20px]">
                        <button onClick={prev} className='border-[2px] border-[--button-color] text-[--button-color] p-[2px] rounded-[5px] hover:bg-[--button-color] hover:text-white duration-300 transition-all'>
                            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14 16.75C13.808 16.75 13.616 16.6771 13.47 16.5301L9.46999 12.5301C9.17699 12.2371 9.17699 11.762 9.46999 11.469L13.47 7.46902C13.763 7.17602 14.238 7.17602 14.531 7.46902C14.824 7.76202 14.824 8.23705 14.531 8.53005L11.0611 12L14.531 15.47C14.824 15.763 14.824 16.238 14.531 16.531C14.384 16.677 14.192 16.75 14 16.75Z" fill="currentColor" />
                            </svg>
                        </button>
                        <button onClick={next} className='border-[2px] border-[--button-color] text-[--button-color] p-[2px] rounded-[5px] hover:bg-[--button-color] hover:text-white duration-300 transition-all'>
                            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 16.75C9.80802 16.75 9.61599 16.6771 9.46999 16.5301C9.17699 16.2371 9.17699 15.762 9.46999 15.469L12.94 11.999L9.46999 8.52908C9.17699 8.23608 9.17699 7.76104 9.46999 7.46804C9.76299 7.17504 10.238 7.17504 10.531 7.46804L14.531 11.468C14.824 11.761 14.824 12.2361 14.531 12.5291L10.531 16.5291C10.384 16.6771 10.192 16.75 10 16.75Z" fill="currentColor" />
                            </svg>
                        </button>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Banner